import { render } from "./ButtonDownload.vue?vue&type=template&id=6b0c275c&scoped=true"
import script from "./ButtonDownload.vue?vue&type=script&lang=js"
export * from "./ButtonDownload.vue?vue&type=script&lang=js"

import "./ButtonDownload.vue?vue&type=style&index=0&id=6b0c275c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b0c275c"]])

export default __exports__